import MessageText from './MessageText';

const MessageVideo = ({message}) => {
    return message.video_url && <><div className="i-chats-dialogue-content-message-video">
        <video controls>
            <source src={message.video_url}/>
            <a href={message.video_url} target='_blank' rel="noopener noreferrer">
                <span>{message.video_url}</span>
            </a>
        </video>
    </div>
    <MessageText text={message.text}/>
    </>
}

export default MessageVideo;